module.exports = __webpack_public_path__ + "static/media/arrow_right.2c98226c.svg";